export const maskCellPhone = (phoneNumber: string): string => {
    let result = phoneNumber
    const value = phoneNumber
        .replace(/[^0-9]/g, '')
        .replace(/[a-z]/gi, '')
        .match(/(\d{0,2})(\d{0,5})(\d{0,4})/)
    if (value) {
        if (!value[2]) {
            result = value[1]
        } else if (!value[3]) {
            result = `(${value[1]}) ${value[2]}`
        } else {
            result = `(${value[1]}) ${value[2]}-${value[3]}`
        }
    }

    return result
}

export const maskBirthDate = (birthDate: string): string => {
    let result = birthDate
    const value = birthDate
        .replace(/[a-z]/gi, '')
        .replace(/[^0-9]/g, '')
        .match(/(\d{0,2})(\d{0,2})(\d{0,4})/)
    if (value) {
        if (!value[2]) {
            result = value[1]
        } else if (!value[3]) {
            result = `${value[1]}/${value[2]}`
        } else {
            result = `${value[1]}/${value[2]}/${value[3]}`
        }
    }
    return result
}

export const formattedBirthDateBR = (date: string | undefined) => {
    if (date) {
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    }
    return ''
}

export const formattedBirthDateUSA = (date: string | undefined) => {
    if (date) {
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    }
    return ''
}
